import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IAddress } from '../../services/address.service';
import { ModalController } from '@ionic/angular';
import { AddressEditorModalComponent } from '../address-editor-modal/address-editor-modal.component';
import { LoaderService } from '../../services/loader.service';
import { FormatAddressPipe } from '../../pipes/address.form.pipe';
import { IStore } from 'src/app/store/services/store.service';

@Component({
    selector: 'shared-address',
    templateUrl: './address.component.html',
    styleUrls: ['./address.component.scss'],
    standalone: false
})

export class AddressComponent implements OnInit {
  @Input() placeHolder: string;
  @Input() submitted: boolean;
  @Input() skipProvinceValidation: boolean = false;
  @Input() isReservation:boolean;
  @Input() storeId: string;
  @Output() onChange: EventEmitter<IAddress> = new EventEmitter<IAddress>();

  address: IAddress;

  get text() {
    if (!this.address)
      return this.placeHolder;

    return this.formatAddress.transform(this.address);
  }

  constructor(private modalCtrl: ModalController,
              private formatAddress: FormatAddressPipe,
              private loader: LoaderService) { }

  ngOnInit() {}

  async beginChangeAddress() {
    const modal = await this.modalCtrl.create({
      component: AddressEditorModalComponent,
      componentProps: {
        skipProvinceValidation: this.skipProvinceValidation,
        isReservation: this.isReservation,
        storeId: this.storeId
      },
      cssClass: 'custom-border-modal-css'
    });

    modal
      .onDidDismiss()
      .then(async (result) => {
        if (!result.data)
          return;

        this.address = result.data;
        this.onChange.emit(this.address);
      });

    await modal.present();
  }
}